<template>
  <div class="favourite-route-wrap">

    <div
      v-if="editable && editMode"
      class="favourite-delete-icon"
      @click="removeRoute()"
    >
      <md-icon>remove_circle</md-icon>
    </div>

    <router-link
      :to="{
        name: 'routeinfo',
        params: {
            id: favouriteRoute.routeid,
        },
        query: {
            routedir: favouriteRoute.routedir,
            stopseq: favouriteRoute.stopseq,
        },
      }"
      class="full-width-link favourite-route"
    >
      <div class="route-info">

        <div class="route-upper">
          <div class="routec">
            {{ favouriteRoute.routec }}
          </div>
          <div class="stopc">
            {{ favouriteRoute.stopc }}
          </div>
        </div>

        <div class="route-lower">
          <div class="destin">{{
              favouriteRoute.routedir === 2 ? favouriteRoute.destinc :
                favouriteRoute.startc
            }}
          </div>
        </div>

      </div>
      <div class="route-eta">
        <GetEta
          :stop-details="favouriteRoute"
        />
      </div>
    </router-link>

  </div>
</template>

<script>
import GetEta from "../Eta/GetEta";
import {mapActions, mapState} from "vuex";

export default {
  name: "FavouriteRoute",
  components: {GetEta},
  props: [
    'favouriteRoute',
    'editable',
  ],
  computed: {
    ...mapState('favourite', ['editMode']),

  },
  methods: {
    ...mapActions('favourite', ['removeFavourite']),

    removeRoute() {
      this.removeFavourite(this.favouriteRoute);
    },
  },
  mounted() {

  },
}
</script>

<style scoped>
/*.full-width-link{
    width: 100%;
}*/

.favourite-route-wrap {
  display: flex;
  justify-content: space-between;
  padding: 0 8px;
}

.favourite-delete-icon {
  margin-right: 4px;
}

.favourite-route {
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
}

.route-upper {
  font-size: 16px;
  marginBottom: 2px;
}

.routec, .stopc {
  display: inline-block;
}

.routec {
  margin-right: 8px;
  font-weight: bold;
}

.route-lower {
  font-size: 12px;
  color: #4D4D4D;
}

.destin::before {
  content: '往';
  margin-right: 4px;
}

.route-info, .route-eta {
  display: inline-block;
}

.route-info {
  flex-grow: 3;
}

.route-eta {
  flex-grow: 2;
}
</style>
